import { publicUrlFor } from "../../../../../globals/constants";
import JobZImage from "../../../../common/jobz-img";

function SectionOfficePhotos2() {
    return (
        <>
            <h4 className="twm-s-title">Office Photos</h4>
            <div className="tw-sidebar-gallery-2">
                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic1.jpg")} title="Title 1" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic1.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic1.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic2.jpg")} title="Title 2" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic2.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic2.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <div className="tw-service-gallery-thumb ">
                            <a className="elem" href={publicUrlFor("images/gallery/pic3.jpg")} title="Title 3" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic3.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic3.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic4.jpg")} title="Title 4" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic4.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic4.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionOfficePhotos2;